const SHOW_SHOPPING_CART = 'nibi_business/show/SHOW_SHOPPING_CART';
const SHOW_CREATE_MODAL = 'nibi_business/show/SHOW_CREATE_MODAL';
const SHOW_REQUESTED_BENEFIT_MODAL = 'nibi_business/show/SHOW_REQUESTED_BENEFIT_MODAL';

const initialState = {
  showShoppingCart: false,
  showCreateModal: false,
  showRequestedBenefitModal: false,
  createModalTab: -1,
  hideTabs: false
};

export default function reducer(state = initialState, action) {
  const payload = action.payload;

  switch (action.type) {
    case SHOW_SHOPPING_CART:
      return {
        ...state,
        showShoppingCart: payload
      };
    case SHOW_CREATE_MODAL:
      return {
        ...state,
        showCreateModal: payload.show,
        createModalTab: payload.createModalTab >= 0 ? payload.createModalTab : -1,
        hideTabs: payload.hideTabs ? payload.hideTabs : false
      };
    case SHOW_REQUESTED_BENEFIT_MODAL:
      return {
        ...state,
        showRequestedBenefitModal: payload.show
      };
    default:
      return state;
  }
}

export function setShowShoppingCart(payload) {
  return { type: SHOW_SHOPPING_CART, payload };
}

export function setShowCreateModal(payload) {
  return { type: SHOW_CREATE_MODAL, payload };
}

export function setShowRequestedBenefitModal(payload) {
  return { type: SHOW_REQUESTED_BENEFIT_MODAL, payload };
}
